import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	deleteCalendarModalHeader: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.delete-modal.delete-calendar-modal-header',
		defaultMessage: 'Delete Calendar',
		description: 'Modal header text when deleting a calendar',
	},
	deleteCalendarModalBody: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.delete-modal.delete-calendar-modal-body',
		defaultMessage: 'Are you sure you wish to delete this calendar:',
		description: 'Modal body text when deleting a calendar',
	},
	deleteButton: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.delete-modal.delete-button',
		defaultMessage: 'Confirm',
		description: 'Delete button text',
	},
	cancelButton: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.delete-modal.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Cancel button text',
	},
	errorMessage: {
		id: 'servicedesk-sla-settings.calendars.summary-with-actions.delete-modal.error-message',
		defaultMessage: 'Something has gone wrong. An error has occurred.',
		description: 'Error message for delete calendar',
	},
});
